// batching.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { BatchQueueService } from '@app/services/batch-queue.service';
import * as moment from 'moment';

const BATCHABLE_PATHS = [
  //'/api/data/GetWarningMsgOnValueChange',
  //'Expose/LoadBomChilds',
  //'/api/data/PushDataToBackend',
  //'/api/data/GetItemPrice',
  'GetPropertySourceQueue',
  //'GetManyModuleHeaderData'
];

@Injectable()
export class BatchingInterceptor implements HttpInterceptor {
  constructor(private batcher: BatchQueueService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // never batch the batch endpoint itself
    if (req.headers.has('x-batch-exempt')) return next.handle(req);

    // only batch certain calls (POSTs to a specific path; adjust as needed)
    const isBatchable = BATCHABLE_PATHS.some(
      (path) => req.url.indexOf(path) != -1
    );

    // log why the request is not batched
    if (!isBatchable) return next.handle(req);

    Date.prototype.toJSON = function () {
      return moment(this).format();
    };

    return new Observable<HttpEvent<any>>((observer) => {
      const id = Math.random().toString(36).slice(2);
      this.batcher.enqueue({
        id,
        url: req.urlWithParams,
        method: req.method,
        body: JSON.stringify(req.body),
        headers: this.headersToObject(req),
        resolve: (body: any) => {
          observer.next(new HttpResponse({ body, status: 200, url: req.url }));
          observer.complete();
        },
        reject: (err: any) => observer.error(err),
      });

      // teardown (no-op)
      return () => {};
    });
  }

  private headersToObject(req: HttpRequest<any>): Record<string, string> {
    const out: Record<string, string> = {};
    req.headers.keys().forEach((k) => {
      out[k] = req.headers.get(k)!;
    });
    return out;
  }
}
